import { EpimsBaseEntityDto } from './epim-base.dto';
export class EncroachmentTypeDto extends EpimsBaseEntityDto {

    EncroachmentTypeId: string;

    EncroachmentTypeName: string; 
      
    length: number;

}